import {Alert, Form, Modal, Select} from "antd";
import TextArea from "antd/es/input/TextArea";
import {PageType} from "../../../api/config";
import {useEffect, useState} from "react";


interface ModalOpts {
    pageType?: PageType
    pageTypes: PageType[]
    urls?: string[]
    onOk: (pageTypeID: number, urls: string[]) => Promise<void>,
    onCancel?: () => void
}

export function StartUrlsAddModal({pageType, pageTypes, urls, onOk, onCancel}: ModalOpts) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")

    const onFinish = (values: any) => {
        console.log('Received values of form:', values);
    };

    const initialValues = {
        pageTypeID: pageType?.id || null,
        urls: urls?.join("\n") || "",
    }

    useEffect(() => {
        form.setFieldValue("pageTypeID", pageType?.id)
    }, [pageType, pageTypes])

    return <Modal title="Стартовые урлы" open={true} okText={"OK"} cancelText={"Отмена"} okButtonProps={{}} onOk={
        () => {
            form
                .validateFields()
                .then(values => {
                    console.log(values.pageTypeID, values.urls.split("\n"));

                    (async () => {
                        setLoading(true)
                        try {
                            await onOk(values.pageTypeID, values.urls.split("\n"))
                        } catch (err: any) {
                            setLoading(false)
                            setError(err.toString())
                            return
                        }
                        setLoading(false)
                        form.resetFields()
                    })()
                })
        }
    } onCancel={onCancel} confirmLoading={loading}>
        <Form form={form} name="dynamic_form_nest_item" onFinish={onFinish} autoComplete="off" layout={"vertical"}
              initialValues={initialValues}
        >
            {
                error && <Alert showIcon type={"error"} message={"Ошибка"} description={error}/>
            }
            <Form.Item
                label="Тип страницы"
                name={"pageTypeID"}
                required={true}
                rules={[{required: true, message: 'Обязательное поле'}]}
            >
                <Select disabled={pageType != null}
                        options={pageTypes.map(item => ({
                            label: `${item.name} (id=${item.id})`,
                            value: item.id
                        }))}
                />
            </Form.Item>

            <Form.Item required label={"Список урлов:"} help={"Одна строчка = один урл"} name={"urls"}
                       rules={[
                           {required: true, message: 'Обязательное поле'}
                       ]}
            >
                <TextArea></TextArea>
            </Form.Item>
        </Form>
    </Modal>
}